module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioPrimerQuiz.5202d3fa.pdf";